import moment from 'moment';

export default {
  contactChats(state, getters, rootState, rootGetters) {
    if (!rootState.profile) {
      return [];
    }
    let signinUsername = rootState.profile.username;
    let chats = [];

    for (let key in state.chats) {
      if (!state.chats.hasOwnProperty(key)) {
        continue;
      }
      let chatDto = state.chats[key];
      // ignore temp chat which was created temporarily for the participant who is never chat before.
      // if (key.toLowerCase().indexOf('temp') >= 0) {
      //   continue;
      // }

      let participants = Array.from(chatDto.participants.values());
      let participantUsername = participants[0] !== signinUsername ? participants[0] : participants[1];
      let participant = rootState.user.users[participantUsername] || {};
      let participantDisplayName = participant.displayname || '';
      let nameFilter = rootState.user.filter.name;
      // filter chat by keyword
      if (nameFilter && participantDisplayName.indexOf(nameFilter) < 0) {
        continue;
      }

      let unreadCount = chatDto.unreadMessageCount(signinUsername);
      let chatMessageDto = chatDto.lastChatMessage();
      let updateTime = chatMessageDto.id ? chatMessageDto.timeStamp : chatDto.createdFrom;

      let lastMessage;
      if (chatMessageDto.IsText()) {
        lastMessage = chatMessageDto.text;
      } else if (chatMessageDto.IsImage()) {
        lastMessage = '傳送了圖片';
      } else if (chatMessageDto.IsAudio()) {
        lastMessage = '傳送了錄音';
      }

      let lastMessageTime;
      if (chatMessageDto.timeStamp) {
        lastMessageTime = getMessageReadTime(chatMessageDto.timeStamp);
      }

      chats.push({
        id: chatDto.id,
        participant,
        unreadCount,
        updateTime,
        lastMessage,
        lastMessageTime
      });
    }

    // desc sorting by updateTime
    return chats.sort((a, b) => b.updateTime-a.updateTime);
  },

  currentUnreadMessageCount(state, getters, rootState, rootGetters) {
    if (!rootState.profile || !state.currentChat.id) {
      return 0;
    }
    let signinUsername = rootState.profile.username;
    return state.currentChat.unreadMessageCount(signinUsername);
  },

  chatMessages(state, getters, rootState, rootGetters) {
    if (!state.currentChat || !rootState.profile) {
      return [];
    }

    let signinUsername = rootState.profile.username;
    let messages = state.currentChat.messages || [];
    let result = [];

    messages.forEach(message => {
      let avatar;
      if (message.speaker !== signinUsername) {
        let userDto = rootState.user.users[state.currentChatUsername] || {};
        avatar = userDto.avatar;
      }

      message.avatar = avatar;
      result.push(message);
    });

    // sort by timestamp
    return result.sort((a, b) => a.timeStamp-b.timeStamp);
  }
};


function getMessageReadTime(timestamp) {
  let targetTime = moment(timestamp);
  let currentTime = moment();

  if (targetTime.date() === currentTime.date()) {
    return targetTime.format('hh:mm');
  }

  let diffDates = Math.abs(targetTime.date() - currentTime.date());
  if (diffDates === 1) {
    return '昨天';
  }

  return targetTime.format('MM/DD');
}